var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheriff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7266 117.578C37.7188 119.25 38.8516 120.875 41.0859 121.531L40.2578 122.875C38.6406 122.391 37.5 121.391 36.8672 120.117C36.2422 121.531 35.0547 122.641 33.3516 123.172L32.4766 121.797C34.7578 121.102 35.9609 119.391 35.9766 117.609V117.516H32.9766V116.109H40.6484V117.516H37.7266V117.578ZM34.6641 129.219V123.625H36.3984V125.078H42.0859V123.625H43.8203V129.219H34.6641ZM36.3984 127.812H42.0859V126.422H36.3984V127.812ZM42.0859 123.031V115.266H43.8203V118.359H45.7891V119.797H43.8203V123.031H42.0859ZM50.4766 116.047C52.6484 116.047 54.2734 117.43 54.2891 119.422C54.2734 121.414 52.6484 122.812 50.4766 122.812C48.2969 122.812 46.6562 121.414 46.6641 119.422C46.6562 117.43 48.2969 116.047 50.4766 116.047ZM46.9609 127.938C48.7812 127.281 49.6875 125.82 49.6953 124.422V123.812H51.3672V124.422C51.3516 125.617 51.8906 126.844 53.1016 127.648C54.3281 126.797 54.8828 125.492 54.8984 124.422V123.812H56.5859V124.422C56.5938 125.922 57.4609 127.312 59.3203 127.938L58.4609 129.219C57.1016 128.727 56.1953 127.812 55.7109 126.68C55.2578 127.805 54.4297 128.82 53.1328 129.344C51.8047 128.836 50.9688 127.867 50.5156 126.734C50.0156 127.828 49.1172 128.734 47.8203 129.219L46.9609 127.938ZM48.3672 119.422C48.3594 120.609 49.2656 121.344 50.4766 121.344C51.6797 121.344 52.5781 120.609 52.5859 119.422C52.5781 118.273 51.6797 117.5 50.4766 117.5C49.2578 117.5 48.3594 118.273 48.3672 119.422ZM55.9141 123.203V115.266H57.6484V118.438H59.6172V119.844H57.6484V123.203H55.9141ZM71.3984 115.266V120.625H73.5703V122.047H71.3984V129.406H69.6641V115.266H71.3984ZM60.9141 125.953V116.609H67.5234V118.016H62.6484V124.5C64.8438 124.492 66.5859 124.383 68.5234 124.047L68.7266 125.516C66.5312 125.891 64.6328 125.953 62.0859 125.953H60.9141ZM90.8672 126.25V127.672H77.9609V126.25H80.9453V122.68C79.8203 122.031 79.1406 121.016 79.1484 119.766C79.1406 117.516 81.3438 116.031 84.3828 116.031C87.4375 116.031 89.6562 117.516 89.6484 119.766C89.6562 121 88.9922 121.992 87.8984 122.641V126.25H90.8672ZM80.8516 119.766C80.8438 121.211 82.2734 122.133 84.3828 122.125C86.4844 122.133 87.9453 121.211 87.9453 119.766C87.9453 118.297 86.4844 117.398 84.3828 117.406C82.2734 117.398 80.8438 118.297 80.8516 119.766ZM82.6641 126.25H86.1328V123.305C85.5938 123.422 85.0078 123.484 84.3828 123.484C83.7734 123.484 83.1953 123.422 82.6641 123.312V126.25ZM103.211 118.859V120.266H99.0859V121.812H104.68V123.219H91.7891V121.812H97.3672V120.266H93.4609V115.5H95.1953V118.859H103.211ZM93.4141 129.219V124.312H103.07V129.219H93.4141ZM95.1016 127.812H101.383V125.688H95.1016V127.812ZM108.523 116.688L108.352 124.672H106.586L106.398 116.688H108.523ZM106.258 126.906C106.25 126.25 106.805 125.711 107.477 125.703C108.125 125.711 108.68 126.25 108.68 126.906C108.68 127.578 108.125 128.125 107.477 128.125C106.805 128.125 106.25 127.578 106.258 126.906Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 49.0005C119.019 75.5258 97.5238 97.0205 70.9985 97.0205C44.4732 97.0205 22.9785 75.5258 22.9785 49.0005C22.9785 22.4751 44.4732 0.980469 70.9985 0.980469C97.5238 0.980469 119.019 22.4751 119.019 49.0005Z",
    fill: "url(#paint0_linear_1275_5279)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1275_5279)",
    filter: "url(#filter0_i_1275_5279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.734 36.7072C96.7777 37.2578 95.625 37.1639 94.784 36.5578L87.599 49.0003L94.784 61.4386C95.625 60.8325 96.7777 60.7386 97.734 61.2892C99.0361 62.0404 99.4801 63.7051 98.7287 65.0027C97.9773 66.3046 96.3124 66.7485 95.0145 65.9973C94.0582 65.4467 93.5673 64.4009 93.6697 63.3679H79.2997L72.1146 75.8147C73.0581 76.2416 73.7156 77.1891 73.7156 78.2947C73.7156 79.7972 72.4989 81.0137 70.9961 81.0137C69.4934 81.0137 68.2766 79.7972 68.2766 78.2947C68.2766 77.1891 68.9341 76.2416 69.8776 75.8147L62.6968 63.3765H48.331C48.4335 64.4094 47.9426 65.4509 46.9863 66.0058C45.6842 66.7571 44.0234 66.3131 43.2721 65.0113C42.5207 63.7094 42.9647 62.049 44.2668 61.2977C45.2231 60.7471 46.3758 60.841 47.2168 61.4471L54.3975 49.0003L47.2125 36.5621C46.3715 37.1682 45.2188 37.2621 44.2625 36.7115C42.9604 35.9602 42.5164 34.2955 43.2678 32.9979C44.0192 31.6961 45.6842 31.2521 46.982 32.0034C47.9383 32.554 48.4292 33.5998 48.3268 34.6328H62.6926L69.8776 22.1945C68.9341 21.7677 68.2766 20.8201 68.2766 19.7145C68.2766 18.212 69.4934 16.9955 70.9961 16.9955C72.4989 16.9955 73.7156 18.212 73.7156 19.7145C73.7156 20.8201 73.0581 21.7677 72.1146 22.1945L79.2997 34.6328H93.6655C93.563 33.5998 94.054 32.5583 95.0103 32.0034C96.3124 31.2521 97.9731 31.6961 98.7244 32.9979C99.4801 34.2955 99.0318 35.956 97.734 36.7072Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.49 49.0009C113.49 72.4678 94.4668 91.4914 70.9999 91.4914C47.533 91.4914 28.5093 72.4678 28.5093 49.0009C28.5093 25.534 47.533 6.5103 70.9999 6.5103C94.4668 6.5103 113.49 25.534 113.49 49.0009Z",
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5279",
    x: 42.9062,
    y: 16.9873,
    width: 56.1875,
    height: 65.0526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5279"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5279",
    x: 27.2266,
    y: 5.22754,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5279",
    x1: 37.6785,
    y1: 11.4338,
    x2: 107.749,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1275_5279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.1867,
    height: 64.0267,
    fill: "white",
    transform: "matrix(1 0 0 -1 42.9062 81.0137)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheriff);
export default __webpack_public_path__ + "static/media/Sheriff.52a775d143d15c28b079c1e393bd8ad2.svg";
export { ForwardRef as ReactComponent };